// import React, { useEffect, useState } from "react";
// import { FaTrashAlt, FaEdit } from "react-icons/fa";
// import { ImSpinner2 } from "react-icons/im";
// import Cookies from "js-cookie";


// const AddCompaniesPage = () => {
//   const [companies, setCompanies] = useState([]);
//   const [form, setForm] = useState({ name: "", location: "", industry: "" });
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);

 
  
//     let adminid = "";
//     adminid = Cookies.get("sessionidadmin");

//   const fetchCompanies = async () => {
//     try {
//       setIsLoading(true);
//       const res = await fetch("https://api.terraweb.africa/getcompanies");
//       const data = await res.json();
//       setCompanies(data);
//     } catch (err) {
//       setError("Failed to fetch companies.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       setIsLoading(true);
//       setError(null);
//       const res = await fetch("https://api.terraweb.africa/addcompany", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(form),
//       });
//       if (!res.ok) throw new Error("Server error");
//       await fetchCompanies();
//       setForm({ name: "", location: "", industry: "" });
//     } catch (err) {
//       setError("Failed to add company.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCompanies();
//   }, []);
//   const handleEdit = async (company) => {
//     const updatedName = prompt("Edit company name", company.name);
//     const updatedLocation = prompt("Edit location", company.location);
//     const updatedIndustry = prompt("Edit industry", company.industry);
  
//     if (!updatedName || !updatedLocation || !updatedIndustry) return;
  
//     try {
//       setIsLoading(true);
//       const res = await fetch("https://api.terraweb.africa/editcompany", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           id: company.id,
//           name: updatedName,
//           location: updatedLocation,
//           industry: updatedIndustry,
//           adminid,
//         }),
//       });
//       if (!res.ok) throw new Error("Edit failed");
//       await fetchCompanies();
//     } catch (err) {
//       setError("Failed to edit company.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this company?")) return;
  
//     try {
//       setIsLoading(true);
//       const res = await fetch("https://api.terraweb.africa/deletecompany", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id, adminid }),
//       });
//       if (!res.ok) throw new Error("Delete failed");
//       await fetchCompanies();
//     } catch (err) {
//       setError("Failed to delete company.");
//     } finally {
//       setIsLoading(false);
//     }
//   };
  

//   return (
//     <div className="min-vh-100 bg-orange pa4 black">
//       <h1 className="f2 fw6 mb4">Add Company</h1>

//       <div className="bg-white black br3 pa4 center mb5 mw6 shadow-5">
//         <form onSubmit={handleSubmit} className="flex flex-column gap3">
//           <input
//             className="input-reset ba b--black-20 pa2 mb2 db w-100"
//             type="text"
//             placeholder="Company Name"
//             value={form.name}
//             onChange={(e) => setForm({ ...form, name: e.target.value })}
//             required
//           />
//           <input
//             className="input-reset ba b--black-20 pa2 mb2 db w-100"
//             type="text"
//             placeholder="Location"
//             value={form.location}
//             onChange={(e) => setForm({ ...form, location: e.target.value })}
//             required
//           />
//           <input
//             className="input-reset ba b--black-20 pa2 mb2 db w-100"
//             type="text"
//             placeholder="Industry"
//             value={form.industry}
//             onChange={(e) => setForm({ ...form, industry: e.target.value })}
//             required
//           />
//           <button type="submit" className="w-100 pa2 bg-orange white bn br2">
//           {isLoading ? <ImSpinner2 className="spin" /> : "Add Company"}

//           </button>
//           {error && <p className="dark-red fw5">{error}</p>}
//         </form>
//       </div>

//       <div className="bg-white br3 pa3 shadow-5">
//         <h2 className="f4 fw6 mb3">Companies List</h2>
//         {isLoading ? (
//           <p className="gray">Loading companies...</p>
//         ) : (
//           <table className="collapse w-100">
//             <thead className="bg-washed-orange">
//               <tr>
//                 <th className="tl pa2">Name</th>
//                 <th className="tl pa2">Location</th>
//                 <th className="tl pa2">Industry</th>
//                 <th className="tl pa2">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {companies.map((company) => (
//                 <tr key={company.id} className="bb b--black-10">
//                   <td className="pa2">{company.name}</td>
//                   <td className="pa2">{company.location}</td>
//                   <td className="pa2">{company.industry}</td>
//                   <td className="pa2">
//                   <button className="br2 ba b--black-20 bg-white mr2 pointer">
//   <FaEdit className="orange" />
// </button>
// <button className="br2 ba b--dark-red bg-white pointer">
//   <FaTrashAlt className="dark-red" />
// </button>

//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AddCompaniesPage;


import React, { useEffect, useState } from "react";
import { FaTrashAlt, FaEdit } from "react-icons/fa";
import { ImSpinner2 } from "react-icons/im";
import Cookies from "js-cookie";
import "./AddCompaniesPage.css"; // custom CSS file

const AddCompaniesPage = () => {
   const adminid = Cookies.get("sessionidadmin") || "";
  const [companies, setCompanies] = useState([]);
  const [form, setForm] = useState({ adminid:adminid?adminid:"", name: "", location: "", industry: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
 
  


  const fetchCompanies = async () => {
    try {
      setIsLoading(true);
      const res = await fetch("https://api.terraweb.africa/getcompaniesAdmin");
      const data = await res.json();
      setCompanies(data);
    } catch (err) {
      setError("Failed to fetch companies.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      setError(null);
      const res = await fetch("https://api.terraweb.africa/addcompany", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("Server error");
      await fetchCompanies();
      setForm({ name: "", location: "", industry: "" });
    } catch (err) {
      setError("Failed to add company.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = async (company) => {
    const updatedName = prompt("Edit company name", company.name);
    const updatedLocation = prompt("Edit location", company.location);
    const updatedIndustry = prompt("Edit industry", company.industry);
    if (!updatedName || !updatedLocation || !updatedIndustry) return;

    try {
      setIsLoading(true);
      const res = await fetch("https://api.terraweb.africa/editcompany", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: company.id,
          name: updatedName,
          location: updatedLocation,
          industry: updatedIndustry,
          adminid,
        }),
      });
      if (!res.ok) throw new Error("Edit failed");
      await fetchCompanies();
    } catch (err) {
      setError("Failed to edit company.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this company?")) return;

    try {
      setIsLoading(true);
      const res = await fetch("https://api.terraweb.africa/deletecompany", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, adminid }),
      });
      if (!res.ok) throw new Error("Delete failed");
      await fetchCompanies();
    } catch (err) {
      setError("Failed to delete company.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  return (
    <div className="page-container">
      <div className="card">
        <h1 className="header">Company Management</h1>

        {/* Add Company Form */}
        <div className="form-section">
          <h2>Add New Company</h2>
          <form onSubmit={handleSubmit} className="company-form">
            <input
              type="text"
              placeholder="Company Name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              required
            />
            <input
              type="text"
              placeholder="Location"
              value={form.location}
              onChange={(e) => setForm({ ...form, location: e.target.value })}
              required
            />
            <input
              type="text"
              placeholder="Industry"
              value={form.industry}
              onChange={(e) => setForm({ ...form, industry: e.target.value })}
              required
            />
            <button type="submit"className="w5 center br-pill pa4">
              {isLoading ? <ImSpinner2 className="spinner" /> : "Add Company"}
            </button>
            {error && <p className="error">{error}</p>}
          </form>
        </div>

        <hr className="divider" />

        {/* Company List */}
        <div className="table-section">
          <h2>Companies List</h2>
          {isLoading ? (
            <p>Loading companies...</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Location</th>
                  <th>Industry</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {companies.map((company, index) => (
                  <tr key={company.id} className={index % 2 === 0 ? "even" : "odd"}>
                    <td>{company.name}</td>
                    <td>{company.location}</td>
                    <td>{company.industry}</td>
                    <td>
                      <button className="edit-btn" onClick={() => handleEdit(company)}>
                        <FaEdit />
                      </button>
                      <button className="delete-btn" onClick={() => handleDelete(company.id)}>
                        <FaTrashAlt />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddCompaniesPage;
